import React from "react";
import EditSupplier from "../../../Features/Forms/Suppliers/Edit";

const Edit = () => {
  return (
    <div>
      <EditSupplier />
    </div>
  );
};

export default Edit;
